import {
  defaultWorkspaceApiClient,
  type WorkspaceApiRequest,
} from '../cloud/services/workspace-api-client';
import type { PermissionSnapshotResponse } from '../permissions/stores/permission-snapshot';
import type { WorkspaceMetadataDeltaPage } from './types';

type MetadataDeltaPageOptions = {
  first: number;
  priority: NonNullable<WorkspaceApiRequest['priority']>;
  signal?: AbortSignal;
};

export type WorkspaceMetadataDeltaPageEnvelope = WorkspaceMetadataDeltaPage & {
  permissionSnapshot?: PermissionSnapshotResponse;
};

/**
 * Shared transport for document and folder projection deltas.
 *
 * Both projections consume the same mixed metadata page and apply only their
 * own item shape. A single coordinator identity lets simultaneous consumers
 * share the exact server read without coupling their independent reducers.
 */
export function fetchWorkspaceMetadataDeltaPage(
  workspaceId: string,
  token: string,
  options: MetadataDeltaPageOptions
): Promise<WorkspaceMetadataDeltaPageEnvelope> {
  const query = new URLSearchParams({
    since: token,
    first: String(options.first),
  });
  return defaultWorkspaceApiClient.requestJson({
    workspaceId,
    path: `/api/workspaces/${workspaceId}/metadata/changes?${query.toString()}`,
    category: 'metadata',
    key: `metadata-changes:${token}:first:${options.first}`,
    priority: options.priority,
    mode: 'background',
    init: {
      method: 'GET',
      signal: options.signal,
    },
  });
}
